import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { chooseReachoutMessageToDisplay } from 'portfolio-shared/util/reachoutUtils';

export default class Reachout extends Component {

  static propTypes = {
    reachoutMessages: PropTypes.array,
    dismissedMessageIds: PropTypes.array,
    className: PropTypes.string,
    classNameDismiss: PropTypes.string,
    onDismissMessage: PropTypes.func.isRequired,
    openLink: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.chooseReachoutMessage = this.chooseReachoutMessage.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  chooseReachoutMessage() {
    const { reachoutMessages, dismissedMessageIds } = this.props;
    return chooseReachoutMessageToDisplay(reachoutMessages, dismissedMessageIds);
  }

  handleDismiss() {
    const rm = this.chooseReachoutMessage();
    if (rm) {
      this.props.onDismissMessage(rm.id);
    }
  }

  render() {
    const { className, classNameDismiss, openLink } = this.props;

    const reachoutMessage = this.chooseReachoutMessage();
    if (!reachoutMessage) {
      return null;
    }

    const { text, url, urlText } = reachoutMessage;

    return (
      <div
        className={className}
        style={{ width: '100%', position: 'relative', lineHeight: '30px', paddingLeft: '10px', paddingRight: '35px' }}
      >
        <span key="message">{text}</span>
        {url && (
          <span 
            onClick={() => openLink(url)} // eslint-disable-line react/jsx-no-bind
            className={className} 
            style={{ marginLeft: '10px', textDecoration: 'underline', cursor: 'pointer' }}
          >
            {urlText || url}
          </span>
        )}
        <span
          className="fa-stack"
          style={{ position: 'absolute', right: '10px', top: '4px', fontSize: '11px' }}
          onClick={this.handleDismiss}
        >
          <i className="fa fa-circle fa-stack-2x" />
          <i className={'fa fa-close fa-stack-1x fa-lg ' + classNameDismiss} />
        </span>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/portfolio-shared/view/Reachout/Reachout.js